import { useEffect, useRef } from 'react';

export default function useDebounce(effect, dependencies, delay, allowEffectOnMount = false) {
  const isFirstMount = useRef(!allowEffectOnMount);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }

    const timeout = setTimeout(effect, delay);
    return () => clearTimeout(timeout);
  }, dependencies);
}
